module.exports = __webpack_public_path__ + "img/depa_logo.2fe6f97f.png";